'use client'

import { Domain } from '../../../domain-config/domain-config'
import { HotelNameSize } from '@/components/ui/search/HotelNameSize'
import React, { ReactElement } from 'react'
import { useIsWhiteLabel } from '@/lib/hooks'
import classNames from 'classnames'
import Skeleton from 'react-loading-skeleton'
import { formatHotelUrl, getHotelName, renderXTimes } from '@/lib/utils/utils'

export function TitleStar(props: { size?: HotelNameSize }): ReactElement {
  return (
    <div
      className={classNames('z-40 inline-block align-top', {
        'h-2.5 w-2.5': props.size === HotelNameSize.STANDARD,
        'h-2 w-2': props.size === HotelNameSize.SMALL || props.size === HotelNameSize.VERY_SMALL,
        'h-3 w-3': props.size === HotelNameSize.LARGE,
        'h-[14px] w-[14px]': !props.size,
      })}
    >
      <svg viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 0.5L8.6458 5.23475L13.6574 5.33688L9.66296 8.36525L11.1145 13.1631L7 10.3L2.8855 13.1631L4.33704 8.36525L0.342604 5.33688L5.3542 5.23475L7 0.5Z" />
      </svg>
    </div>
  )
}

export function HotelName(props: {
  domain: Domain
  skeleton: boolean
  hotelName: string
  url?: string
  stars: number
  categoryText: string
  size: HotelNameSize
  additionalClassName?: string
  allowWrap?: boolean
  openInNewWindow?: boolean
  bottomMargin?: string
  additionalClassNameWrapper?: string
  tag: string
}): ReactElement {
  const isWhitelabelPage = useIsWhiteLabel()
  const splitHotelName = getHotelName(props.hotelName)

  const LinkOrSpan = props.tag as keyof JSX.IntrinsicElements
  return (
    <div
      className={classNames(props.bottomMargin, props.additionalClassNameWrapper, {
        'whitespace-normal leading-5': props.allowWrap,
        table: !props.allowWrap,
      })}
    >
      <LinkOrSpan
        href={props.url && formatHotelUrl(props.url)}
        className={classNames('mr-2 text-stone-900', props.additionalClassName, {
          'text-base': props.size === HotelNameSize.VERY_SMALL,
          'text-xl': props.size === HotelNameSize.SMALL,
          'text-2xl': props.size === HotelNameSize.STANDARD,
          'text-3xl font-semibold md:text-4xl': props.size === HotelNameSize.LARGE,
          'w-80': props.skeleton,
        })}
        {...(props.openInNewWindow
          ? { target: isWhitelabelPage ? undefined : '_blank', rel: 'noreferrer noopener' }
          : {})}
      >
        {props.skeleton ? <Skeleton /> : splitHotelName[0]}{' '}
        <span className="inline-flex whitespace-nowrap">
          {!props.skeleton && splitHotelName[1]}{' '}
          {!props.skeleton && props.stars > 0 && (
            <div className="ml-0.5 inline-block align-top">
              {renderXTimes(props.stars, TitleStar, props)}
            </div>
          )}
          {props.categoryText && (
            <div className="ml-0.5 inline-block align-top">
              <div
                className={classNames('z-40 inline-block w-4 align-top', {
                  'text-[8px] leading-[8px]':
                    props.size === HotelNameSize.SMALL || props.size === HotelNameSize.VERY_SMALL,
                  'text-[10px] leading-[10px]': props.size === HotelNameSize.STANDARD,
                  'text-[11px] leading-[12px]': props.size === HotelNameSize.LARGE,
                })}
              >
                {props.categoryText}
              </div>
              {/*<div className="absolute top-0 inline-block align-top">{props.categoryText}aaa</div>*/}
            </div>
          )}
        </span>
      </LinkOrSpan>
    </div>
  )
}
